var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: { "close-on-content-click": false, "offset-y": "" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function(ref) {
              var on = ref.on
              return [
                !_vm.trackingNumber ||
                ((!_vm.details || !_vm.details.length) && !_vm.isServer)
                  ? _c(
                      "span",
                      [
                        _vm._t("default"),
                        _vm._v(" "),
                        !_vm.$slots.default
                          ? _c("span", [_vm._v(_vm._s(_vm.tracking))])
                          : _vm._e()
                      ],
                      2
                    )
                  : _c(
                      "a",
                      _vm._g(
                        {
                          attrs: {
                            title: _vm.$t("viewTrackRecord"),
                            linkify: ""
                          }
                        },
                        on
                      ),
                      [
                        _vm._t("default"),
                        _vm._v(" "),
                        !_vm.$slots.default
                          ? _c("span", [_vm._v(_vm._s(_vm.tracking))])
                          : _vm._e()
                      ],
                      2
                    ),
                _vm._v(" "),
                !!_vm.trackStatus
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "p",
                                    _vm._g(
                                      {
                                        staticClass:
                                          "text-xs-center cursor-pointer"
                                      },
                                      on
                                    ),
                                    [
                                      _vm._v(
                                        _vm._s(_vm.trackStatus.toLowerCase())
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.trackDescription))])
                      ]
                    )
                  : _vm._e()
              ]
            }
          }
        ],
        null,
        true
      ),
      model: {
        value: _vm.display,
        callback: function($$v) {
          _vm.display = $$v
        },
        expression: "display"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "py-2" },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("trackingDetails")))]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.isServer
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        small: "",
                        loading: _vm.loading,
                        disabled: !_vm.tracking
                      },
                      on: { click: _vm.fetchTrackingDetails }
                    },
                    [_c("v-icon", [_vm._v("refresh")])],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _vm.error
                ? _c(
                    "div",
                    { staticClass: "text-center py-4 text-error" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mb-2", attrs: { color: "error" } },
                        [_vm._v("error")]
                      ),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.error))])
                    ],
                    1
                  )
                : _c(
                    "v-data-table",
                    {
                      attrs: {
                        loading: _vm.loading,
                        headers: [
                          {
                            text: this.$t("time"),
                            align: "left",
                            sortable: false,
                            value: "timestamp"
                          },
                          {
                            text: this.$t("event"),
                            align: "left",
                            sortable: false,
                            value: "desc"
                          },
                          {
                            text: this.$t("address"),
                            align: "left",
                            sortable: false,
                            value: "address"
                          }
                        ],
                        items: _vm.trackingDetails,
                        "item-key": "serviceType",
                        "hide-actions": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "items",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    item.timestamp &&
                                      _vm.formatFedexLocalScanTime(item)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.desc))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.address))])
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "template",
                        { slot: "no-data" },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: { row: "", wrap: "", "text-xs-center": "" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(this.$t("noEventsOfThisTracking")) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { "text-xs-center": "" } }, [
            _vm._v(_vm._s(_vm.$t("packageStatusUpdateHint")))
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _vm.carrier
                ? _c(
                    "a",
                    {
                      attrs: { linkify: "" },
                      on: { click: _vm.trackOnCarrierSite }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("trackOnCarrierSite", {
                            tracking: _vm.tracking
                          })
                        )
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.display = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9294140", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9294140","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelTrackingDetailWidget.vue
// module id = null
// module chunks = 